import { render, staticRenderFns } from "./ButtonDefault.vue?vue&type=template&id=8158c15c&scoped=true&"
import script from "./ButtonDefault.vue?vue&type=script&lang=js&"
export * from "./ButtonDefault.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDefault.vue?vue&type=style&index=0&id=8158c15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8158c15c",
  null
  
)

export default component.exports